export default __webpack_public_path__ + "static/media/pdf.b0736cb4.svg";